import React, { useState, useEffect } from 'react';

import EthereumAddressTextField from '../component/EthereumAddressTextField';
import FieldSetFormControl from '../component/FieldSetFormControl';
import HexStringTextField from '../component/HexStringTextField';

import Box from "@material-ui/core/Box";
import Divider from "@material-ui/core/Divider";

import { ethers } from 'ethers';

function KeyToAddress (props) {
  const {
    ...other
  } = props;

  const [ key, setKey ] = useState ('');
  const [ compressedPublicKey, setCompressedPublicKey ] = useState ('');
  const [ uncompressedPublicKey, setUncompressedPublicKey ] = useState ('');
  const [ address, setAddress ] = useState ('');
  const [ error, setError ] = useState (undefined);

  useEffect (() => {
    try {
      if (key.trim ().length % 2 === 1)
        throw new Error ('Odd number of hexadecimal digits');
      setCompressedPublicKey (ethers.utils.computePublicKey (key.trim (), true));
      setUncompressedPublicKey (ethers.utils.computePublicKey (key.trim (), false));
      setAddress (ethers.utils.computeAddress (key.trim ()));
      setError (undefined);
    } catch (error) {
      setCompressedPublicKey ('');
      setUncompressedPublicKey ('');
      setAddress ('');
      setError (error.message);
    }
  }, [ key ]);

  return (
    <Box my={-1}
         component={FieldSetFormControl}
         fullWidth
         {...other}>
      <Box my={1}
           component={HexStringTextField}
           label="Private or public key"
           rows={0}
           validator={() => error}
           value={key}
           onChange={event => setKey (event.target.value)} />
      <Box mt={1}
           mb={3}>
        <Divider />
      </Box>
      <Box my={1}
           component={HexStringTextField}
           label="Public key (compressed)"
           rows={0}
           readOnly
           value={compressedPublicKey} />
      <Box my={1}
           component={HexStringTextField}
           label="Public key (uncompressed)"
           rows={0}
           readOnly
           value={uncompressedPublicKey} />
      <Box my={1}
           component={EthereumAddressTextField}
           label="Address"
           readOnly={true}
           value={address} />
    </Box>
  );
}

export default KeyToAddress;
